<template>
    <div
        class="equipment-tile"
        :class="[
            isMotor ? 'tile-motor' : 'tile-machine',
            componentData.isWorkshopChild ? 'workshop-child' : ''
        ]"
        @click="enableActionButtons()"
    >
        <div class="info-container">
            <div class="name-container">
                <div class="tile-icon-image">
                    <img src="static/images/motor-image.svg">
                </div>
                <h2>{{ componentData.name }}</h2>
            </div>
            <div class="title-container">
                <ConsumptionPercentBadge
                    ref="consumptionPercentBadge"
                    :uid="componentData.uid"
                    entity="equipment"                   
                />
                <div class="tile-text">
                    <div class="meter-container">
                        <div class="meter-icon-container">
                            <img :src="energyMeterIcon(componentData.energy_meter)" alt="" class="meter-icon">
                        </div>
                        <span class="meter-name">{{ componentData.energy_meter_name }}</span>
                    </div>
                    <div
                        v-if="componentData.simulation_measure"
                        class="compute-icon"
                    >
                        <v-icon
                            name="check-circle"
                        ></v-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ConsumptionPercentBadge from '@/components/partials/ui/ConsumptionPercentBadge.vue';
    export default {
        name: 'MotorCard',
        components: {
            ConsumptionPercentBadge
        },
        props: {
            componentData: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapGetters(['currentSite', 'energyMeterIcon']),
            isMotor() {
                return this.componentData.equipment_type === 'motor';
            },
        },
        methods: {
            enableActionButtons(){
                this.$emit('enableActionButtons', this.componentData);
            },
            openEquipmentForm() {
                this.$store.commit('SET_CURRENT_EQUIPMENT', { ...this.componentData });
                this.$router.push({
                    name: 'Equipment',
                    params: {
                        siteUid: this.currentSite.uid,
                        parentAreaUid: this.componentData.parent_area_uid
                    }
                });
            },
            deleteItem(){
                this.$confirm(`Voulez-vous vraiment supprimer ${this.isMotor ? 'cet moteur' : 'cette machine'} ?`, this.componentData.name, {
                    type: 'warning',
                    confirmButtonText: 'Confirmer',
                    cancelButtonText: 'Annuler',
                })
                .then(() =>{
                    this.$store.dispatch('patchItem',{
                        item:{
                            archived: true,
                            url: this.componentData.url,
                            uid: this.componentData.uid
                        },
                        model: 'equipment',
                        url: this.$store.state.api.meta.listModels.equipment.url,
                    }).then(() => {
                        this.$emit('refreshTree');
                        this.$notify({
                            title: 'Success',
                            message: `${this.componentData.name} à été supprimé.`,
                            type: 'success'
                        });
                    }).catch((error) => {
                        this.$notify({
                            title: 'Error',
                            message: `Erreur lors de la suppression de ${this.componentData.name}.`,
                            type: 'error'
                        });
                    });
                }).catch(() => {
                    return;
                });
            },
            refreshConsumptionPercent(){
                this.$refs.consumptionPercentBadge.getConsumptionPercent();
            }
        }
    }
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/page/Synoptic/Equipments/MotorCard.vue